var datepickerlocale=[];

//Lang code - af - START
datepickerlocale.af=[];
datepickerlocale.af.monthNames=["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"];
datepickerlocale.af.daysOfWeek=["Son","Maa","Din","Woe","Don","Vry","Sat"];
//Lang code - af - END

//Lang code - ar - START
datepickerlocale.ar=[];
datepickerlocale.ar.monthNames=["يناير","فبراير","مارس","ابريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","اكتوبر","نوفمبر","ديسمبر"];
datepickerlocale.ar.daysOfWeek=["الأحد","الإثنين","الثلاثاء","الأربعاء","الخميس","الجمعه","السبت"];

for(var i=0;i<=(datepickerlocale.ar.daysOfWeek.length-1);i++)
{
    datepickerlocale.ar.daysOfWeek[i]="<span class='day'>"+datepickerlocale.ar.daysOfWeek[i]+"</span>";
}
//Lang code - ar - END

//Lang code - az - START
datepickerlocale.az=[];
datepickerlocale.az.monthNames=["Yanvar","Fevral","Mart","Aprel","May","İyun","İyul","Avqust","Sentyabr","Oktyabr","Noyabr","Dekabr"];
datepickerlocale.az.daysOfWeek=["B","Be","Ça","Ç","Ca","C","Ş"];
//Lang code - az - END

//Lang code - bg - START
datepickerlocale.bg=[];
datepickerlocale.bg.monthNames=["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"];
datepickerlocale.bg.daysOfWeek=["Нед","Пон","Вто","Сря","Чет","Пет","Съб"];
//Lang code - bg - END

//Lang code - bs - START
datepickerlocale.bg=[];
datepickerlocale.bg.monthNames=["Januar","Februar","Mart","April","Maj","Juni","Juli","August","Septembar","Oktobar","Novembar","Decembar"];
datepickerlocale.bg.daysOfWeek=["Ned","Pon","Uto","Sri","Čet","Pet","Sub"];
//Lang code - bs - END

//Lang code - ca - START
datepickerlocale.ca=[];
datepickerlocale.ca.monthNames=["Gener","Febrer","Mar&ccedil;","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"];
datepickerlocale.ca.daysOfWeek=["Dug","Dln","Dmt","Dmc","Djs","Dvn","Dsb"];
//Lang code - ca - END

//Lang code - cs - START
datepickerlocale.cs=[];
datepickerlocale.cs.monthNames=["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"];
datepickerlocale.cs.daysOfWeek=["ne","po","út","st","čt","pá","so"];
//Lang code - cs - END

//Lang code - cy - START
datepickerlocale.cy=[];
datepickerlocale.cy.monthNames=["ខែ​មករា","ខែ​កុម្ភៈ","ខែ​មិនា","ខែ​មេសា","ខែ​ឧសភា","ខែ​មិថុនា","ខែ​កក្កដា","ខែ​សីហា","ខែ​កញ្ញា","ខែ​តុលា","ខែ​វិច្ឆិកា","ខែ​ធ្នូ"];
datepickerlocale.cy.daysOfWeek=["អា","ចន្ទ","អង្គ","ពុធ","ព្រហ","សុ","សៅរ៍"];
//Lang code - cy - END

//Lang code - da - START
datepickerlocale.da=[];
datepickerlocale.da.monthNames=["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"];
datepickerlocale.da.daysOfWeek=["Søn","Man","Tir","Ons","Tor","Fre","Lør"];
//Lang code - da - END

//Lang code - de - START
datepickerlocale.de=[];
datepickerlocale.de.monthNames=["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
datepickerlocale.de.daysOfWeek=["So","Mo","Di","Mi","Do","Fr","Sa"];
//Lang code - de - END

//Lang code - el - START
datepickerlocale.el=[];
datepickerlocale.el.monthNames=["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάιος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"];
datepickerlocale.el.daysOfWeek=["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"];
//Lang code - el - END

//Lang code - eo - START
datepickerlocale.eo=[];
datepickerlocale.eo.monthNames=["Januaro","Februaro","Marto","Aprilo","Majo","Junio","Julio","Aŭgusto","Septembro","Oktobro","Novembro","Decembro"];
datepickerlocale.eo.daysOfWeek=["Dim","Lun","Mar","Mer","Ĵaŭ","Ven","Sab"];
//Lang code - eo - END

//Lang code - es - START
datepickerlocale.es=[];
datepickerlocale.es.monthNames=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
datepickerlocale.es.daysOfWeek=["Dom","Lun","Mar","Mi&eacute;","Juv","Vie","S&aacute;b"];
//Lang code - es - END

//Chinmay Gandhi - 30th Oct 2019 - Introduce new language Norwegian [ RES-2280 ] - START
datepickerlocale.eu=[];
datepickerlocale.eu.monthNames=["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"];
datepickerlocale.eu.daysOfWeek=["Søn","Man","tys","Ons","Tor","Fre","Lør"];
//Chinmay Gandhi - 30th Oct 2019 - Introduce new language Norwegian [ RES-2280 ] - eu - END

//Lang code - fa - START
datepickerlocale.fa=[];
datepickerlocale.fa.monthNames=["فروردين","ارديبهشت","خرداد","تير","مرداد","شهريور","مهر","آبان","آذر","دي","بهمن","اسفند"];
datepickerlocale.fa.daysOfWeek=["ي","د","س","چ","پ","ج","ش"];
//Lang code - fa - END

//Lang code - fi - START
datepickerlocale.fi=[];
datepickerlocale.fi.monthNames=["Tammikuu","Helmikuu","Maaliskuu","Huhtikuu","Toukokuu","Kes&auml;kuu","Hein&auml;kuu","Elokuu","Syyskuu","Lokakuu","Marraskuu","Joulukuu"];
datepickerlocale.fi.daysOfWeek=["Su","Ma","Ti","Ke","To","Pe","Su"];
//Lang code - fi - END

//Lang code - fo - START
datepickerlocale.fi=[];
datepickerlocale.fi.monthNames=["Januar","Februar","Mars","Apríl","Mei","Juni","Juli","August","September","Oktober","November","Desember"];
datepickerlocale.fi.daysOfWeek=["Sun","Mán","Týs","Mik","Hós","Frí","Ley"];
//Lang code - fo - END

//Lang code - fr - START
datepickerlocale.fr=[];
datepickerlocale.fr.monthNames=["Janvier","F&#233;vrier","Mars","Avril","Mai","Juin","Juillet","Ao&#251;t","Septembre","Octobre","Novembre","D&#233;cembre"];
datepickerlocale.fr.daysOfWeek=["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"];
//Lang code - fr - END

//Lang code - hr - START
datepickerlocale.hr=[];
datepickerlocale.hr.monthNames=["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"];
datepickerlocale.hr.daysOfWeek=["Ned","Pon","Uto","Sri","Čet","Pet","Sub"];
//Lang code - hr - END

//Lang code - ht - START
datepickerlocale.ht=[];
datepickerlocale.ht.monthNames=["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"];
datepickerlocale.ht.daysOfWeek=["周日","周一","周二","周三","周四","周五","周六"];
//Lang code - ht - END

//Lang code - hu - START
datepickerlocale.hu=[];
datepickerlocale.hu.monthNames=["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"];
datepickerlocale.hu.daysOfWeek=["Vas","Hét","Ked","Sze","Csü","Pén","Szo"];
//Lang code - hu - END

//Lang code - hy - START
datepickerlocale.hy=[];
datepickerlocale.hy.monthNames=["Հունվար","Փետրվար","Մարտ","Ապրիլ","Մայիս","Հունիս","Հուլիս","Օգոստոս","Սեպտեմբեր","Հոկտեմբեր","Նոյեմբեր","Դեկտեմբեր"];
datepickerlocale.hy.daysOfWeek=["կիր","երկ","երք","չրք","հնգ","ուրբ","շբթ"];
//Lang code - hy - END

//Lang code - id - START
datepickerlocale.id=[];
datepickerlocale.id.monthNames=["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","Nopember","Desember"];
datepickerlocale.id.daysOfWeek=["Min","Sen","Sel","Rab","kam","Jum","Sab"];
//Lang code - id - END

//Lang code - is - START
datepickerlocale.is=[];
datepickerlocale.is.monthNames=["Jan&uacute;ar","Febr&uacute;ar","Mars","Apr&iacute;l","Ma&iacute","J&uacute;n&iacute;","J&uacute;l&iacute;","&Aacute;g&uacute;st","September","Okt&oacute;ber","N&oacute;vember","Desember"];
datepickerlocale.is.daysOfWeek=["Sun","M&aacute;n","&THORN;ri","Mi&eth;","Fim","F&ouml;s","Lau"];
//Lang code - is - END

//Lang code - it - START
datepickerlocale.it=[];
datepickerlocale.it.monthNames=["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"];
datepickerlocale.it.daysOfWeek=["Dom","Lun","Mar","Mer","Gio","Ven","Sab"];
//Lang code - it - END

//Lang code - iw - START
datepickerlocale.iw=[];
datepickerlocale.iw.monthNames=["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"];
datepickerlocale.iw.daysOfWeek=["א'","ב'","ג'","ד'","ה'","ו'","שבת"];
//Lang code - iw - END

//Lang code - ja - START
datepickerlocale.ja=[];
datepickerlocale.ja.monthNames=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
datepickerlocale.ja.daysOfWeek=["日","月","火","水","木","金","土"];
//Lang code - ja - END

//Lang code - ko - START
datepickerlocale.ko=[];
datepickerlocale.ko.monthNames=["1월(JAN)","2월(FEB)","3월(MAR)","4월(APR)","5월(MAY)","6월(JUN)","7월(JUL)","8월(AUG)","9월(SEP)","10월(OCT)","11월(NOV)","12월(DEC)"];
datepickerlocale.ko.daysOfWeek=["일","월","화","수","목","금","토"];
//Lang code - ko - END

//Lang code - lt - START
datepickerlocale.lt=[];
datepickerlocale.lt.monthNames=["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"];
datepickerlocale.lt.daysOfWeek=["sek","pir","ant","tre","ket","pen","šeš"];
//Lang code - lt - END

//Lang code - lv - START
datepickerlocale.lv=[];
datepickerlocale.lv.monthNames=["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"];
datepickerlocale.lv.daysOfWeek=["svt","prm","otr","tre","ctr","pkt","sst"];
//Lang code - lv - END

//Lang code - ms - START
datepickerlocale.ms=[];
datepickerlocale.ms.monthNames=["Januari","Februari","Mac","April","Mei","Jun","Julai","Ogos","September","Oktober","November","Disember"];
datepickerlocale.ms.daysOfWeek=["Aha","Isn","Sel","Rab","kha","Jum","Sab"];
//Lang code - ms - END

//Lang code - nl - START
datepickerlocale.nl=[];
datepickerlocale.nl.monthNames=["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"];
datepickerlocale.nl.daysOfWeek=["zon","maa","din","woe","don","vri","zat"];
//Lang code - nl - END

//Lang code - no - START
datepickerlocale.no=[];
datepickerlocale.no.monthNames=["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"];
datepickerlocale.no.daysOfWeek=["Søn","Man","tys","Ons","Tor","Fre","Lør"];
//Lang code - no - END

//Lang code - pl - START
datepickerlocale.pl=[];
datepickerlocale.pl.monthNames=["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"];
datepickerlocale.pl.daysOfWeek=["Nie","Pn","Wt","Śr","Czw","Pt","So"];
//Lang code - pl - END

//Lang code - pt - START
datepickerlocale.pt=[];
datepickerlocale.pt.monthNames=["Janeiro","Fevereiro","Mar&ccedil;o","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
datepickerlocale.pt.daysOfWeek=["Dom","Seg","Ter","Qua","Qui","Sex","Sab"];
//Lang code - pt - END

//Lang code - pt-BR - START
datepickerlocale['pt-BR']=[];
datepickerlocale['pt-BR'].monthNames=["Janeiro","Fevereiro","Mar&ccedil;o","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
datepickerlocale['pt-BR'].daysOfWeek=["Dom","Seg","Ter","Qua","Qui","Sex","Sab"];
//Lang code - pt-BR - END

//Lang code - ro - START
datepickerlocale.ro=[];
datepickerlocale.ro.monthNames=["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"];
datepickerlocale.ro.daysOfWeek=["Dum","Lun","Mar","Mie","Joi","Vin","Sâm"];
//Lang code - ro - END

//Lang code - ru - START
datepickerlocale.ru=[];
datepickerlocale.ru.monthNames=["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"];
datepickerlocale.ru.daysOfWeek=["вск","пнд","втр","срд","чтв","птн","сбт"];
//Lang code - ru - END

//Lang code - sk - START
datepickerlocale.sk=[];
datepickerlocale.sk.monthNames=["Január","Február","Marec","Apríl","Máj","Jún","Júl","August","September","Október","November","December"];
datepickerlocale.sk.daysOfWeek=["Ned","Pon","Uto","Str","Štv","Pia","Sob"];
//Lang code - sk - END

//Lang code - sl - START
datepickerlocale.sl=[];
datepickerlocale.sl.monthNames=["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"];
datepickerlocale.sl.daysOfWeek=["Ned","Pon","Tor","Sre","&#x10C;et","Pet","Sob"];
//Lang code - sl - END

//Lang code - sq - START
datepickerlocale.sq=[];
datepickerlocale.sq.monthNames=["Janar","Shkurt","Mars","Prill","Maj","Qershor","Korrik","Gusht","Shtator","Tetor","Nëntor","Dhjetor"];
datepickerlocale.sq.daysOfWeek=["Di","Hë","Ma","Më","En","Pr","Sh"];
//Lang code - sq - END

//Lang code - sr - START
datepickerlocale.sr=[];
datepickerlocale.sr.monthNames=["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"];
datepickerlocale.sr.daysOfWeek=["Нед","Пон","Уто","Сре","Чет","Пет","Суб"];
//Lang code - sr - END

//Lang code - sv - START
datepickerlocale.sv=[];
datepickerlocale.sv.monthNames=["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"];
datepickerlocale.sv.daysOfWeek=["Sön","Mån","Tis","Ons","Tor","Fre","Lör"];
//Lang code - sv - END

//Lang code - ta - START
datepickerlocale.ta=[];
datepickerlocale.ta.monthNames=["தை","மாசி","பங்குனி","சித்திரை","வைகாசி","ஆனி","ஆடி","ஆவணி","புரட்டாசி","ஐப்பசி","கார்த்திகை","மார்கழி"];
datepickerlocale.ta.daysOfWeek=["ஞாயிறு","திங்கள்","செவ்வாய்","புதன்","வியாழன்","வெள்ளி","சனி"];
//Lang code - ta - END

//Lang code - th - START
datepickerlocale.th=[];
datepickerlocale.th.monthNames=["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฏาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"];
datepickerlocale.th.daysOfWeek=["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."];
//Lang code - th - END

//Lang code - tr - START
datepickerlocale.tr=[];
datepickerlocale.tr.monthNames=["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];
datepickerlocale.tr.daysOfWeek=["Pz","Pt","Sa","Ça","Pe","Cu","Ct"];
//Lang code - tr - END

//Lang code - uk - START
datepickerlocale.uk=[];
datepickerlocale.uk.monthNames=["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"];
datepickerlocale.uk.daysOfWeek=["нед","пнд","вів","срд","чтв","птн","сбт"];
//Lang code - uk - END

//Lang code - vi - START
datepickerlocale.vi=[];
datepickerlocale.vi.monthNames=["Tháng Một","Tháng Hai","Tháng Ba","Tháng Tư","Tháng Năm","Tháng Sáu","Tháng Bảy","Tháng Tám","Tháng Chín","Tháng Mười","Tháng Mười Một","Tháng Mười Hai"];
datepickerlocale.vi.daysOfWeek=["CN","T2","T3","T4","T5","T6","T7"];
//Lang code - vi - END

//prashant - 24 june 2021 purpose : change captions in georgian language[RES-2830] --START
//Lang code - yi - START
datepickerlocale.yi=[];
datepickerlocale.yi.monthNames=["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"];
datepickerlocale.yi.daysOfWeek=["კვ","ორ","სმ","ოთ","ხთ","პრ","შბ"];
//Lang code - yi - END
//prashant - 24 june 2021 purpose : change captions in georgian language[RES-2830] --END

//Lang code - zh-CN - START
datepickerlocale['zh-CN']=[];
datepickerlocale['zh-CN'].monthNames=["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"];
datepickerlocale['zh-CN'].daysOfWeek=["周日","周一","周二","周三","周四","周五","周六"];
//Lang code - zh-CN - END

//Lang code - zh-HK - START
datepickerlocale['zh-HK']=[];
datepickerlocale['zh-HK'].monthNames=["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"];
datepickerlocale['zh-HK'].daysOfWeek=["周日","周一","周二","周三","周四","周五","周六"];
//Lang code - zh-HK - END

//Lang code - zh-TW - START
datepickerlocale['zh-TW']=[];
datepickerlocale['zh-TW'].monthNames=["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"];
datepickerlocale['zh-TW'].daysOfWeek=["周日","周一","周二","周三","周四","周五","周六"];
//Lang code - zh-TW - END
